import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { MobileMenuComponent } from '../mobile-menu/mobile-menu.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { LogoComponent } from '../../common/components/logo/logo.component';
import { RouterLink } from '@angular/router';
import { RouteLocations } from '../../common/routing/route-locations.enum';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngxs/store';
import { OpenMobileMenuOpenedAction } from '../../app.state';
import { MatButtonModule } from '@angular/material/button';
import { faDiscord, faPatreon } from '@fortawesome/free-brands-svg-icons';
import { ENVIRONMENT } from '../../common/services/injection-tokens';
import { Environment } from '../../../environments/environment.interface';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    MobileMenuComponent,
    UserMenuComponent,
    LogoComponent,
    RouterLink,
    FaIconComponent,
    MatButtonModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  constructor(
    private _store: Store,
    @Inject(ENVIRONMENT) private _environment: Environment,
  ) {}

  protected readonly patreonLink = this._environment.links.patreonUrl;
  protected readonly discordLink = this._environment.links.discordUrl;

  protected openMobileMenu() {
    this._store.dispatch(new OpenMobileMenuOpenedAction());
  }

  protected readonly RouteLocations = RouteLocations;
  protected readonly faBars = faBars;
  protected readonly faDiscord = faDiscord;
  protected readonly faPatreon = faPatreon;
}
